import React from 'react';

const FeedBack = () => {
  return (
      <iframe className="feedback-iFrame mt-4" src="https://as-sentimentfeedback-dev-003.azurewebsites.net/"></iframe>
  );
};

export default FeedBack;
